<template>
  <nav @click.self="handleCloseDialog">
    <div class="containerDialog">
      <div class="dialogHeader">
        <span class="cancelBtn" @click="handleCloseDialog">キャンセル</span>
        <span></span>
        <span class="titleDialog" @click="handleSave">完了</span>
      </div>

      <div class="dialogContent">
        <div class="picker-group">
          <VueScrollPicker :options="years" v-model="currentYear" />
          <VueScrollPicker :options="months" v-model="currentMonth" />
          <VueScrollPicker :options="days" v-model="currentDay" />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { VueScrollPicker } from "vue-scroll-picker";
import { mapGetters } from "vuex";

export default {
  name: "Dialog",
  components: {
    VueScrollPicker, // export VueScrollPicker is component
  },
  props: {
    title: String,
    date: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      // Birthday must over 18 years old => init day - 18 (years old)
      currentYear: new Date().getFullYear(),
      currentMonth: 1,
      currentDay: 1,
    };
  },
  computed: {
    ...mapGetters(["userDetail", "metadata"]),

    dateSelected() {
      return `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
    },

    years() {
      const currYear = new Date().getFullYear();

      // Get 2 years from now
      return Array.from(
        { length: 2 },
        (_, index) => {
          return {
            value: currYear + index,
            name: currYear + index + "年",
          };
        }
      );
    },
    months() {
      // Get list month if year select == year user 18 years old
      const currMonth = new Date().getMonth() + 1;
      
      if (new Date().getFullYear() == this.currentYear) {
        return Array.from({ length: 12 - currMonth + 1 }, (_, index) => {
          return {
            value: currMonth + index,
            name: currMonth + index + "月",
          };
        });
      }
      return Array.from({ length: currMonth }, (_, index) => {
        return {
          value: index + 1,
          name: index + 1 + "月",
        };
      });
    },
    days() {
      const lastDay = new Date(
        this.currentYear,
        this.currentMonth,
        0
      ).getDate();

      const currYear = new Date().getFullYear();
      const currMonth = new Date().getMonth() + 1;
      const currDay = new Date().getDate();
      if (
        currYear == this.currentYear &&
        currMonth == this.currentMonth
      ) {
        return Array.from({ length: lastDay - currDay + 1 }, (_, index) => {
          return {
            value: currDay + index,
            name: currDay + index + "日",
          };
        });
      } 
      else if (
        currYear + 1 == this.currentYear &&
        currMonth == this.currentMonth
      ) {
        return Array.from({ length: currDay }, (_, index) => {
          return {
            value: index + 1,
            name: index + 1 + "日",
          };
        });
      } 

      return Array.from({ length: lastDay }, (_, index) => {
        return {
          value: index + 1,
          name: index + 1 + "日",
        };
      });
    },
  },
  mounted() {
    if (this.date) {
      const splitDate = this.date.split("-");
      this.currentYear = parseInt(splitDate[0]);
      this.currentMonth = parseInt(splitDate[1]);
      this.currentDay = parseInt(splitDate[2]);
    }
  },
  methods: {
    handleSave() {
      this.$emit("save", this.dateSelected);
    },

    handleCloseDialog() {
      this.$emit("close");
    },
  },
};
</script>

<style src="vue-scroll-picker/lib/style.css"></style>
<style scoped>
.containerDialog {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: 40%;
  min-height: 200px;
  background-color: white;
}

.dialogHeader {
  border-bottom: 1px solid black;
  display: flex;
  justify-content: space-between;
  padding: 6px 12px;
}

.dialogHeader .titleDialog {
  font-weight: bold;
  color: #64c9d1;
}

.dialogContent {
  overflow-y: auto;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.picker-group {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  padding: 0 32px;
}
</style>